import { PrivateRoute } from 'components'
import { PartnerPath, LocationPaths } from 'location.types'
import { RouteObject } from 'react-router'

export const partnerRoutes: RouteObject = {
  path: LocationPaths.Partner,
  lazy: async () => ({
    Component: (await import('components/PageLayout/SecureDetailsLayout')).SecureDetailsLayout
  }),
  children: [
    {
      index: true,
      lazy: async () => ({ Component: (await import('screens/Partner/Redirect')).Redirect })
    },
    {
      path: PartnerPath.SignUp,
      lazy: async () => ({
        Component: (await import('screens/Partner/SignUp')).SignUp
      })
    },
    {
      path: PartnerPath.SignIn,
      lazy: async () => ({
        Component: (await import('screens/Partner/SignIn')).SignIn
      })
    },
    {
      path: PartnerPath.CodeRedemption,
      lazy: async () => ({
        Component: (await import('screens/Partner/CodeRedemption')).CodeRedemption
      })
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          path: PartnerPath.SteloEligibility,
          lazy: async () => ({
            Component: (await import('screens/Partner/SteloEligibility')).SteloEligibility
          })
        },
        {
          path: PartnerPath.Address,
          lazy: async () => ({
            Component: (await import('screens/Partner/Address')).Address
          })
        },
        {
          path: PartnerPath.ClaimOffer,
          lazy: async () => ({
            Component: (await import('screens/Partner/ClaimOffer')).ClaimOffer
          })
        },
        {
          path: PartnerPath.ScheduleCall,
          lazy: async () => ({
            Component: (await import('screens/Partner/ScheduleCall')).ScheduleCall
          })
        },
        {
          path: PartnerPath.CompleteAccount,
          lazy: async () => ({
            Component: (await import('screens/Partner/CompleteAccount')).CompleteAccount
          })
        },
        {
          path: PartnerPath.Confirmed,
          lazy: async () => ({
            Component: (await import('screens/Partner/Confirmed')).Confirmed
          })
        },
        {
          path: PartnerPath.Ineligible,
          lazy: async () => ({
            Component: (await import('screens/Partner/Ineligible')).Ineligible
          })
        },
        {
          path: PartnerPath.Checkout,
          lazy: async () => ({
            Component: (await import('screens/Partner/Checkout')).Checkout
          })
        },
        {
          path: PartnerPath.ProgramEligibility,
          lazy: async () => ({
            Component: (await import('screens/Partner/ProgramEligibility')).ProgramEligibility
          })
        },
        {
          path: PartnerPath.ChooseInsuranceProvider,
          lazy: async () => ({
            Component: (
              await import('screens/Partner/ChooseInsuranceProvider/ChooseInsuranceProvider')
            ).ChooseInsuranceProvider
          })
        },
        {
          path: PartnerPath.ChoosePolicyHolder,
          lazy: async () => ({
            Component: (await import('screens/Partner/ChoosePolicyHolder')).ChoosePolicyHolder
          })
        },
        {
          path: PartnerPath.InsuranceInformation,
          lazy: async () => ({
            Component: (await import('screens/Partner/InsuranceInformation')).InsuranceInformation
          })
        }
      ]
    }
  ]
}
